<div class="flex-fill d-flex flex-column card p-3">
  <div class="d-flex flex-fill flex-column">
    <dx-data-grid #dataGrid keyExpr="id" class="flex-fill d-flex flex-column" [dataSource]="journalEntries" (onRowDblClick)="rowDoubleClick($event)">
      <dxi-column dataField="id" width="75"></dxi-column>
      <dxi-column dataField="docNumber" width="125"></dxi-column>
      <dxi-column dataField="amount" [format]="{ type: 'currency', precision: 2 }" width="125"></dxi-column>
      <dxi-column dataField="journalEntryDate" caption="Date" dataType="date" width="100"></dxi-column>
      <dxi-column dataField="debitAccount.displayName" caption="Debit Account" width="250"></dxi-column>
      <dxi-column dataField="creditAccount.displayName" caption="Credit Account" width="250"></dxi-column>
      <dxi-column dataField="description" width="225"></dxi-column>
      <dxi-column dataField="notes" width="225"></dxi-column>
      <dxi-column dataField="quickBooksId" caption="QB Id" width="100"></dxi-column>
      <dxi-column dataField="quickBooksLastExport" caption="QB Export" dataType="date" width="100"></dxi-column>
      <dxi-column></dxi-column>

      <div *dxTemplate="let cell of 'linkTemplate'">
        @if (cell.data) {
          <a [routerLink]="[]" (click)="open(cell.data)">{{ cell.text }}</a>
        }
      </div>

      <dxo-selection mode="multiple"></dxo-selection>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="journal-entry-overview-grid"></dxo-state-storing>
      <div *dxTemplate="let data of 'toolbarButtons'">
        <button class="btn btn-sm btn-success me-2" (click)="open()">Add</button>
        <button
          class="btn btn-sm btn-primary me-2"
          (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          >
          Edit
        </button>
        <button
          class="btn btn-sm btn-danger me-4"
          (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          >
          Delete
        </button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (journalEntries) {
          <span class="me-3">
            <strong>
              {{ dataGrid.instance.totalCount() + " items" }}
              {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
            </strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>
